import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useChat } from "@/components/chat/ChatWorkspaceContext";
import ChatStudio from "@/components/chat/ChatStudio";

export default function AgentChatWorkspace() {
  const navigate = useNavigate();
  const { controller, fullscreen, setFullscreen, readOnly = false, readOnlyMessage = "" } = useChat();
  useEffect(() => () => setFullscreen(false), [setFullscreen]);
  useEffect(() => {
    if (!fullscreen) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const escape = (event) => {
      if (event.key !== "Escape" || event.defaultPrevented
        || document.querySelector('.cs-command-dialog[data-state="open"], .oa-dialog[data-state="open"]')) return;
      setFullscreen(false);
    };
    window.addEventListener("keydown", escape);
    return () => { document.body.style.overflow = previous; window.removeEventListener("keydown", escape); };
  }, [fullscreen, setFullscreen]);
  return <ChatStudio controller={controller} readOnly={readOnly} readOnlyMessage={readOnlyMessage} variant="launchpad" colorTreatment="warm-full" showDesignControls={false} fullscreen={fullscreen} onFullscreenChange={setFullscreen} onViewCosts={() => { setFullscreen(false); navigate("/agent/sessions"); }} />;
}
